import React from 'react'
import '../assets/Home.css'
import headerimg from '../assets/OWRB header.png'
import Videobtn from '../assets/Button - Video.png'
import Femabtn from '../assets/fema_button.png'
import Findingsbtn from '../assets/findings_button2.png'
import AddiResource from '../components/AddiResource';


export default function Home() {
    return (

        <div>

            <main className="flex-shrink-0 modular min-vh-100 mt-5">

                <img className='my-5' style={{ maxWidth: "100%" }} src={headerimg} />

                <div className="container mt-2">
                    <div className='row'>
                        <div className='col-1 d-none d-lg-block'></div>
                        <div className='col-12 col-lg-10'>

                            <div className="row">
                                <div className="col-md-12 col-xl-2">
                                    <div className="row justify-content-center" style={{ paddingBottom: "10px" }}>
                                        <a href="https://vimeo.com/503096608/c2e637fbe7" target="_blank"><img
                                            src={Videobtn} height="150"
                                            style={{ maxWidth: "100%" }} /></a>
                                    </div>
                                </div>
                                <div className="col-md-12 col-xl-10">
                                    <div className="container">
                                        <div cass="row">
                                            <div className="col">
                                                <p><a href="https://vimeo.com/528029596/430f0ccff4" traget="_blank"><img
                                                    src={Femabtn} style={{ maxWidth: "100%", border: "none" }}
                                                    alt="Click here to watch the March 23rd Virtual FEMA Discovery Presentation and Q&amp;A" /></a>
                                                </p>
                                            </div>
                                        </div>
                                        <div cass="row">
                                            <div className="col">
                                                <p><a href="https://vimeo.com/575892753/a0bc310ad9" traget="_blank"><img
                                                    src={Findingsbtn} style={{ maxWidth: "100%", border: "none" }}
                                                    alt="Click here to watch a recording of the July 16th Virtual FEMA Discovery Findings Presentation" /></a>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <h1 style={{ textAlign: "start" }}>Welcome to OWRB's Discovery 19-2 webpage and survey!</h1>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col" style={{ textAlign: "start" }}>
                                                <p>In 2010, the Federal Emergency Management Agency (FEMA) and the OWRB officially
                                                    launched a Cooperating Technical Partnership (CTP) Agreement. This important
                                                    effort recognized the need for updated flood insurance studies and flood
                                                    insurance map panels, as well as the development of digital flood hazard
                                                    mapping. In 2012, the OWRB and FEMA began the RiskMAP Discovery process for
                                                    Oklahoma's watersheds, which will help communities identify areas at risk for
                                                    flooding and, ultimately, aid in prioritizing future mitigation efforts. If
                                                    you'd like to know more about the CTP Program, forms, resources, training
                                                    opportunities, etc then please visit <a
                                                        href="https://www.owrb.ok.gov/floodplain/ctp.php" target="_blank">Floodplain
                                                        Management CTP | Oklahoma Water Resources Board</a>.</p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col" style={{ textAlign: "start" }}>
                                                <p>Discovery 19-2 focuses on five (5) watersheds: Lower Cimarron, Muddy Boggy, Lower
                                                    Canadian, Kiamichi, and Robert S. Kerr Reservoir. Part of Discovery is to engage
                                                    with the communities to gather feedback on known flooding concerns and to
                                                    provide helpful feedback and documents to assist communities in their flood
                                                    planning efforts.</p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col" style={{ textAlign: "start" }}>
                                                <p>On the left side of this screen, you will find a round blue button that you can
                                                    click on. The blue button links to a Tutorial Video which explains how to take
                                                    the online interactive survey about your watershed. At the top, you'll see an
                                                    orange banner that says "Click here to watch a recording of the March 23rd
                                                    Virtual FEMA Discovery Presentation and Q&amp;A" which you can click on to go
                                                    watch the presentation if you weren't able to attend.</p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col" style={{ textAlign: "start" }}>
                                                <p style={{ fontWeight: "bold" }}>Please Click on Your Watershed Below or use the links
                                                    at the top of the page to view more information and take a Survey about your
                                                    watershed.</p>
                                            </div>
                                        </div>

                                        <div className="row mb-4">
                                            <div className="col">

                                                <div className="embed-container"><small><a
                                                    href="//fni.maps.arcgis.com/apps/Embed/index.html?webmap=7f3a1100ac5d4087aa0d1a8670067242&amp;extent=-98.5074,33.5824,-92.3001,36.5138&amp;home=true&amp;zoom=true&amp;scale=true&amp;disable_scroll=false&amp;theme=light"
                                                    style={{ color: "#0000FF", textAlign: "left" }} target="_blank">View larger
                                                    map</a></small><br /><iframe width="100%" height="700" frameBorder="0"
                                                        scrolling="no" marginHeight="0" marginWidth="0"
                                                        title="Discovery 19-2 Watersheds"
                                                        src="//fni.maps.arcgis.com/apps/Embed/index.html?webmap=7f3a1100ac5d4087aa0d1a8670067242&amp;extent=-98.5074,33.5824,-92.3001,36.5138&amp;home=true&amp;zoom=true&amp;previewImage=false&amp;scale=true&amp;disable_scroll=false&amp;theme=light"></iframe>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>
                        <div className='col-1 d-none d-lg-block'></div>




                    </div>
                </div>
            </main>

            <AddiResource />
        </div>

    )
}

